(function($) {$(document).ready(function() {

	$('.contact-form__icon-link, .contact-form__close, .contact-course__icon-link').on('click', event => {
		event.preventDefault();
		$('.contact-form').toggleClass('show');
	});

	$('.contact-form').on('click', event => {
		// background click close
		if (event.target === event.currentTarget) $('.contact-form').removeClass('show');
	});

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);